export const actionConst = {
    OPEN_EXECUTE_TIME_MODAL: 'OPEN_EXECUTE_TIME_MODAL',
    CLOSE_EXECUTE_TIME_MODAL: 'CLOSE_EXECUTE_TIME_MODAL',
    SHOW_EXECUTE_TIME_OK: 'SHOW_EXECUTE_TIME_OK',
    HIDE_EXECUTE_TIME_OK: 'HIDE_EXECUTE_TIME_OK',
    OPEN_EXECUTER_MODAL: 'OPEN_EXECUTER_MODAL',
    CLOSE_EXECUTER_MODAL: 'CLOSE_EXECUTER_MODAL',
    OPEN_CALENDAR_MODAL: 'OPEN_CALENDAR_MODAL',
    CLOSE_CALENDAR_MODAL: 'CLOSE_CALENDAR_MODAL',
    SHOW_EXECUTER_OK: 'SHOW_EXECUTER_OK',
    HIDE_EXECUTER_OK: 'HIDE_EXECUTER_OK',
    OPEN_MASTER_MODAL: 'OPEN_MASTER_MODAL',
    CLOSE_MASTER_MODAL: 'CLOSE_MASTER_MODAL',
    SHOW_MASTER_OK: 'SHOW_MASTER_OK',
    HIDE_MASTER_OK: 'HIDE_MASTER_OK'
};
